import { CommentSection } from "../../../website/components/comment/CommentSection";
import React from "react";

const DisplayCommentSection: React.FC = () => (
  <div>
    <CommentSection />
  </div>
);

export { DisplayCommentSection };
